import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  trackEvent as trackEventAction,
  trackPage as trackPageAction,
} from 'actions/analytics/tracking';
import { TrackingData } from 'store-types';

const useTracking = () => {
  const dispatch = useDispatch();

  const trackEvent = useCallback(
    (eventName: string, data?: TrackingData) => {
          return dispatch(trackEventAction(eventName, data));
    },
    [dispatch],
  );

  const trackPage = useCallback(
    (data?: TrackingData) => {
          return dispatch(trackPageAction(data));
    },
    [dispatch],
  );

  return {
    trackEvent,
    trackPage,
  };
};

export default useTracking;
